import React from 'react';
import Crop169Icon from '@mui/icons-material/Crop169';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';

const RemoveColumnIcon = () => {
	return (
		<span
			style={{
				position: 'relative',
				display: 'inline-flex',
			}}
		>
			<Crop169Icon sx={{ transform: 'rotate(90deg)', display: 'block' }} size='small' />
			<RemoveCircleIcon
				size='small'
				style={{
					position: 'absolute',
					top: 1,
					right: -2,
					backgroundColor: 'white',
					borderRadius: '50%',
					width: 12,
					height: 12,
					fontSize: '24px',
					pointerEvents: 'none',
				}}
			/>
		</span>
	);
};

export default RemoveColumnIcon;
